import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-27e2df7a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "row mb-4" }
const _hoisted_2 = { class: "col-md-6" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "startDate" }, "Start Date", -1))
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("label", { for: "endDate" }, "End Date", -1))
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "card mb-25 border-0 rounded-0 bg-white stats-box" }
const _hoisted_8 = { class: "card-body pe-20 ps-20 pe-md-25 ps-md-25 pe-lg-15 ps-lg-15" }
const _hoisted_9 = { class: "d-flex align-items-center" }
const _hoisted_10 = { class: "title ms-15" }
const _hoisted_11 = { class: "d-block mb-7 fs-13 text-uppercase fw-medium text-dark-emphasis" }
const _hoisted_12 = { class: "fw-black mb-8 lh-1" }
const _hoisted_13 = {
  key: 0,
  class: "loading-overlay"
}
const _hoisted_14 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "spinner-border",
  role: "status"
}, [
  /*#__PURE__*/_createElementVNode("span", { class: "visually-hidden" }, "Loading...")
], -1))
const _hoisted_15 = [
  _hoisted_14
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          id: "startDate",
          class: "form-control",
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.startDate) = $event)),
          onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.emitDateChange && _ctx.emitDateChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.startDate]
        ])
      ]),
      _createElementVNode("div", _hoisted_4, [
        _hoisted_5,
        _withDirectives(_createElementVNode("input", {
          type: "date",
          id: "endDate",
          class: "form-control",
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.endDate) = $event)),
          onChange: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.emitDateChange && _ctx.emitDateChange(...args)))
        }, null, 544), [
          [_vModelText, _ctx.endDate]
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.stats, (stat, index) => {
        return (_openBlock(), _createElementBlock("div", {
          class: "col-xl-3 col-sm-6",
          key: index
        }, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _createElementVNode("div", {
                  class: _normalizeClass(['icon position-relative rounded-circle text-center', stat.class])
                }, [
                  _createElementVNode("i", {
                    class: _normalizeClass(stat.icon)
                  }, null, 2)
                ], 2),
                _createElementVNode("div", _hoisted_10, [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(stat.title), 1),
                  _createElementVNode("h4", _hoisted_12, _toDisplayString(stat.sign) + _toDisplayString(_ctx.formattedValue(stat.value, stat.format)), 1)
                ])
              ])
            ])
          ])
        ]))
      }), 128))
    ]),
    (_ctx.loading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
      : _createCommentVNode("", true)
  ]))
}